module.exports = __webpack_public_path__ + "static/media/redtail_logo.4a18180c.png";